import React from 'react'
import { InputMask } from 'primereact/inputmask'
import './inputComp.scss'

const InputMaskComp = ({ value, name, mask, onChange, ...propsInput }) => {
  return (
    <InputMask
      name={name}
      value={value}
      mask={mask}
      onChange={onChange}
      {...propsInput}
    />
  )
}

export default InputMaskComp
